import React from "react"
import Layout from "../components/layout"
import PortfolioPage from "../components/PortfolioPage"
import ServicesMainArea from "../components/ServicesMainArea"
import { graphql } from "gatsby"
import Arrow from "../components/Arrow"
import portfolioBanner from "../../static/img/potfolio-banner-hero-one.png"
import useWebsiteCmsContent from "../hooks/useWebsiteCmsContent"
import { localizedBlockData } from "../services/websiteCms"

export default function Portfolio({
  data: {
    markdownRemark: {
      frontmatter: { title, description, lang },
    },
  },
}) {
  const cmsPayload = useWebsiteCmsContent()
  const page = localizedBlockData(cmsPayload, "portfolio-page", lang) || {}

  return (
    <Layout lang={lang} title={page.title || title}>
      <ServicesMainArea img={portfolioBanner} title={page.title || title} description={page.description || description} />
      <div className="b-homepage-content">
        <div className="b-layer-main">
          <Arrow />
          <PortfolioPage lang={lang} />
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        description
        lang
      }
    }
  }
`